import { Component, OnInit } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  firebaseConfig = {
    apiKey: 'AIzaSyBBqktw2-4T_YRHTm_qR_QlXglrvSaLYiM',
    authDomain: 'sharkify-24bd4.firebaseapp.com',
    projectId: 'sharkify-24bd4',
    storageBucket: 'sharkify-24bd4.firebasestorage.app',
    messagingSenderId: '542492962224',
    appId: '1:542492962224:web:1f67c3d86ff81ca0e67a75',
    measurementId: 'G-8ZYPKVZHHJ',
  };

  // app = initializeApp(this.firebaseConfig);
  // messaging = getMessaging(this.app);
  title(title: any) {
    throw new Error('Method not implemented.');
  }
  constructor() {}
  ngOnInit(): void {
    if ('serviceWorker' in navigator) {
      console.log('yes');
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('Service Worker registered successfully:', registration);
          this.activatePushNotifications();
        })
        .catch((err) => {
          console.error('Service Worker registration failed:', err);
        });
    } else {
      console.error('Service Workers are not supported in this browser.');
    }
  }
  display_Loader: boolean = false;
  // FileSelected : any;
  displayLoader(display: boolean) {
    this.display_Loader = display;
  }

  activatePushNotifications() {
    Notification.requestPermission()
      .then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
          // Fetch FCM token
          const firebaseApp = initializeApp(this.firebaseConfig);

          // Export messaging
          const messaging = getMessaging(firebaseApp);
          getToken(messaging, {
            vapidKey:
              'BBpVD9SZh925tH9BnckmtXUiRZmGV06Er0luAJe7vTjAS3IlDDt6BXII8UASrO4Qu2b6khyepMMAB_bpz6MZmo0',
          })
            .then((currentToken) => {
              if (currentToken) {
                console.log('FCM Token:', currentToken);
                localStorage.setItem('PushNotificationToken',currentToken);
                // Todo
                // set the token to localstorage
                // Send the token to your server
              } else {
                console.log('No registration token available.');
              }
            })
            .catch((err) => {
              console.error('Error fetching FCM token:', err);
            });
        } else {
          console.error('Notification permission denied.');
        }
      })
      .catch((err) =>
        console.error('Error requesting notification permission:', err)
      );
  }
}
